import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { useScrollToElement } from '../hooks/useScrollToElement';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const scrollToElement = useScrollToElement();

  return (
    <footer className="pt-12 pb-6 text-white border-t bg-dark-900 border-dark-800">
      <div className="container px-4 mx-auto">
        <div className="grid grid-cols-1 gap-8 mb-8 md:grid-cols-4">
          {/* Company Info */}
          <div className="col-span-1">
            <div className="flex items-center mb-4 space-x-2">
              <Logo className="w-8 h-8" />
              <span className="text-white">WinMax Optimizer</span>
            </div>
            <p className="mb-4 text-dark-300">
              Professional optimization software for Windows systems.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h3 className="mb-4 text-sm font-medium text-white uppercase">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="transition-colors text-dark-300 hover:text-primary-400">Home</Link>
              </li>
              <li>
                <button
                  onClick={() => scrollToElement('features')}
                  className="transition-colors text-dark-300 hover:text-primary-400"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToElement('testimonials')}
                  className="transition-colors text-dark-300 hover:text-primary-400"
                >
                  Testimonials
                </button>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div className="col-span-1">
            <h3 className="mb-4 text-sm font-medium text-white uppercase">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="transition-colors text-dark-300 hover:text-primary-400">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="transition-colors text-dark-300 hover:text-primary-400">Terms of Service</Link>
              </li>
              <li>
                <Link to="/legal-notice" className="transition-colors text-dark-300 hover:text-primary-400">Legal Notice</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-1">
            <h3 className="mb-4 text-sm font-medium text-white uppercase">Contact</h3>
            <p className="text-dark-300">support@winmaxoptimizer.com</p>
          </div>
        </div>

        <div className="pt-6 mt-8 border-t border-dark-800">
          <p className="text-center text-dark-400">
            © {currentYear} WinMax Optimization Software. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;